import type { UIMessage } from 'ai';

import { CopilotThread } from '@/features/copilot';
import { InternalNotesTab } from '@/features/internal-notes';

type CopilotChatStatus = 'ready' | 'submitted' | 'streaming' | 'error';

interface CopilotContentOutletProps {
  activeTab?: string;
  messages: UIMessage[];
  status: CopilotChatStatus;
}

export function CopilotContentOutlet({
  activeTab = 'copilot',
  messages,
  status,
}: CopilotContentOutletProps) {
  switch (activeTab) {
    case 'notepad':
      return <InternalNotesTab />;

    default:
      return <CopilotThread className="h-full" messages={messages} status={status} />;
  }
}
